export const updatedDateChoices = [
    {
        label: '全て',
        value: 'all',
    },
    {
        label: '1週間以内',
        value: '7',
    },
    {
        label: '1ヶ月以内',
        value: '30',
    },
    {
        label: '3ヶ月以内',
        value: '90',
    },
    {
        label: '半年以内',
        value: '180',
    },
    {
        label: '1年以内',
        value: '365',
    },
]

export const jobOfferTypeChoices = [
    {
        label: '介護',
        value: '介護',
    },
    {
        label: '保育',
        value: '保育',
    },
    {
        label: '看護',
        value: '看護',
    },
    {
        label: 'POS・治療',
        value: 'POS・治療',
    },
    {
        label: '技師',
        value: '技師',
    },
    {
        label: '栄養士・調理師',
        value: '栄養士・調理師',
    },
    {
        label: 'デンタル',
        value: 'デンタル',
    },
    {
        label: 'その他',
        value: 'その他',
    },
]

export const jobOfferTypeDefaultChoices = {
    kaigo: ['介護'],
    hoiku: ['保育'],
    kango: ['看護'],
    pos: ['POS・治療'],
    gishi: ['技師'],
    eiyoushi: ['栄養士・調理師'],
    dental: ['デンタル'],
}

export const kaigoQualificationChoices = [
    '介護職・ヘルパー',
    '登録ヘルパー（訪問介護）',
    '介護支援専門員',
    '支援員',
    '社会福祉士',
    '精神保健福祉士（PSW）',
    '医療ソーシャルワーカー（MSW）\u200B', //NOTE: ZeroWidthSpaceが入っているデータがほとんどだったのでそっちもヒットするように
    '医療ソーシャルワーカー（MSW）',
    '生活相談員',
    '支援相談員',
    '看護助手',
    'サービス提供責任者',
    'サービス管理責任者',
    '児童発達支援管理責任者',
    '施設長（施設長候補）',
    '福祉用具専門相談員',
    '事務',
    '介護タクシー（ドライバー）', //NOTE: カッコが"全角"なので注意
]

export const hoikuQualificationChoices = [
    '児童発達支援管理責任者',
    '園長',
    '保育士',
    '保育教諭',
    '幼稚園教諭',
    '保育補助',
    '児童指導員',
    '放課後児童支援員/学童指導員',
]

export const kangoQualificationChoices = [
    '正看護師',
    '助産師',
    '保健師',
    '准看護師',
    '看護助手',
    '治験コーディネーター',
    '医師',
    '薬剤師',
    '歯科衛生士',
]

export const ptotstQualificationChoices = [
    '理学療法士',
    '作業療法士',
    '言語聴覚士',
    'あん摩マッサージ指圧師',
    '鍼灸師',
    '整体師/セラピスト',
    '柔道整復師',
]

export const gishiQualificationChoices = [
    '臨床工学技士',
    '臨床検査技師',
    '診療放射線技師',
]

export const nutritionistQualificationChoices = [
    '栄養士',
    '管理栄養士',
    '調理師',
]

export const dentalQualificationChoices = [
    '歯科衛生士',
    '歯科技工士',
    '歯科助手',
    '歯科医師',
]

export const othersQualificationChoices = ['その他']

export const occupationQualificationChoicesTable = {
    介護: kaigoQualificationChoices,
    保育: hoikuQualificationChoices,
    看護: kangoQualificationChoices,
    'POS・治療': ptotstQualificationChoices,
    技師: gishiQualificationChoices,
    '栄養士・調理師': nutritionistQualificationChoices,
    デンタル: dentalQualificationChoices,
    その他: othersQualificationChoices,
}

export const occupationSortOrders = {
    介護: 1,
    保育: 2,
    看護: 3,
    'POS・技師': 4,
    '栄養士・調理師': 5,
    デンタル: 6,
    その他: 7,
    default: 100,
}
